import { theme as antdTheme } from 'antd';

/** Классическая светлая тема Ant Design — админка и профиль сотрудника */
export const adminAntdTheme = {
  algorithm: antdTheme.defaultAlgorithm,
};

export default adminAntdTheme;
